import { assignInlineVars } from '@vanilla-extract/dynamic';

import { hStack, vStack, spacingVar } from './stack.css';

const stackStyle = (spacing, style) => ({
  ...assignInlineVars({ [spacingVar]: `${spacing}px` }),
  ...style,
});

export const HStack = ({ spacing, style, ...rest }) => (
  <div className={hStack} style={stackStyle(spacing, style)} {...rest} />
);

export const VStack = ({ spacing, style, ...rest }) => (
  <div className={vStack} style={stackStyle(spacing, style)} {...rest} />
);
